import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'openWeatherIcon',
    standalone: false
})
export class OpenWeatherIconPipe implements PipeTransform {

  transform(weatherCode: string): string {
    return `wi-owm-${weatherCode}`;
  }

}
